export default {
    getCategory: () => {
        var str = location.pathname.replace(/\//g, "").replace(/-/g, " ");
        str = str.toLowerCase().split(' ');
        for (var i = 0; i < str.length; i++) {
            str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
        }
        return str.join(' ');
    },
    getCookie: (cookieLabel) => {
        var name = cookieLabel + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    },

    getQueryStringParams: (url) => {
        if (url.charAt(0) === "?") {
            url = url.substring(1);
        }

        var match,
            pl = /\+/g,  // replace add symbol with a space
            search = /([^&=]+)=?([^&]*)/g,
            decode = function (s) { return decodeURIComponent(s.replace(pl, ' ')); },
            params = {};

        while ((match = search.exec(url))) {
            params[decode(match[1]).toLowerCase()] = decode(match[2]);
        }

        return params;
    },

    getUrlParameter: (name) => {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.href);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }
}